import { useQueries, useQuery } from "@tanstack/react-query";
import type { CallInput } from "@agentsaas/client-sdk";
import { useServices } from "../app/services";

/** P6 市场数据 */

export type ListingQuery = NonNullable<CallInput<"listingSearch">["query"]>;

export const mkt = {
  all: ["market"] as const,
  search: (q: ListingQuery) => ["market", "search", q] as const,
  listing: (lid: string) => ["market", "listing", lid] as const,
  mine: (tid: string) => ["market", "mine", tid] as const,
  rentals: (tid: string) => ["market", "rentals", tid] as const,
};

export function useListings(q: ListingQuery) {
  const { api } = useServices();
  return useQuery({ queryKey: mkt.search(q), queryFn: async () => (await api.call("listingSearch", { query: { ...q, limit: 60 } })).items, placeholderData: (p) => p });
}

export function useListing(lid: string | undefined) {
  const { api } = useServices();
  return useQuery({ queryKey: mkt.listing(lid ?? ""), enabled: !!lid, queryFn: () => api.call("listingGet", { params: { lid: lid! } }) });
}

/** 多个商品（我的租用列表显示商品名） */
export function useListingsById(ids: string[]) {
  const { api } = useServices();
  const qs = useQueries({ queries: [...new Set(ids)].map((lid) => ({ queryKey: mkt.listing(lid), queryFn: () => api.call("listingGet", { params: { lid } }), retry: false })) });
  return new Map(qs.flatMap((q) => (q.data ? [[q.data.id as string, q.data] as const] : [])));
}

export function useMyListings(tid: string) {
  const { api } = useServices();
  return useQuery({ queryKey: mkt.mine(tid), queryFn: async () => (await api.call("listingMine", { params: { tid } })).items });
}

export function useRentals(tid: string) {
  const { api } = useServices();
  return useQuery({ queryKey: mkt.rentals(tid), queryFn: async () => (await api.call("rentalList", { params: { tid } })).items });
}
